import http from '../utils/http-client.util';
import * as url from '../comman/url';

export const getOrder = (orderId, saasAccountId) => {
  const params = { orderId };
  if (saasAccountId) params.saasAccountId = saasAccountId;
  return http.get(url.GET_ORDER, params);
}; 
